import { FormlyFieldConfig } from "@ngx-formly/core";

export class EditDeviceProfileForm {

  fields: FormlyFieldConfig[];
  model: {};
  actionText = 'button.save';

  constructor(translateService, deviceProfile, config?) {
    this.model = {
      name: deviceProfile.name,
      class: deviceProfile.class,
      parameters: deviceProfile.parameters ?? {},
    };

    const isSHM = deviceProfile.class === 'StructuralHealthMeasurement';

    this.fields = [
      {
        key: 'name',
        type: 'input',
        wrappers: ['default-wrapper'],
        defaultValue: deviceProfile.name,
        props: {
          required: true,
          disabled: true,
        },
        expressions: {
          'props.label': translateService.stream('fields.name'),
        },
      },
      {
        key: 'class',
        type: 'input',
        wrappers: ['default-wrapper'],
        defaultValue: deviceProfile.class,
        props: {
          required: true,
          disabled: true,
        },
        expressions: {
          'props.label': translateService.stream('fields.class'),
        },
      },
      // StructuralHealthMeasurement parameters
      {
        key: 'parameters.corrosion.barDiameters',
        type: 'chips-number',
        wrappers: ['default-wrapper'],
        defaultValue: deviceProfile.parameters?.corrosion?.barDiameters ?? [],
        hide: !isSHM,
        props: {
          type: 'number',
          required: false,
          suffix: ' mm',
        },
        expressions: {
          'props.label': translateService.stream('fields.barDiameters'),
        },
      },
      {
        key: 'parameters.corrosion.barLengths',
        type: 'chips-number',
        wrappers: ['default-wrapper'],
        defaultValue: deviceProfile.parameters?.corrosion?.barLengths ?? [],
        hide: !isSHM,
        props: {
          type: 'number',
          required: false,
          suffix: ' mm',
        },
        expressions: {
          'props.label': translateService.stream('fields.barLengths'),
        },
      },
    ];
  }
}
